import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-ff table-content flex flex-1" }
const _hoisted_2 = /*#__PURE__*/_createVNode("view", { class: "mar-l-12" }, "公众号首页广告图", -1)
const _hoisted_3 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "f-12 c-99" }, "请上传分辨率为686*200的图片，且不超过 500kb", -1)
const _hoisted_5 = { class: "" }
const _hoisted_6 = /*#__PURE__*/_createVNode("view", { class: "mar-l-12" }, "公众号门店广告图", -1)
const _hoisted_7 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "f-12 c-99" }, "请上传分辨率为686*200的图片，且不超过 500kb", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _hoisted_2,
      _createVNode(_component_el_upload, {
        class: "avatar-uploader",
        action: "https://jsonplaceholder.typicode.com/posts/",
        "show-file-list": false,
        "before-upload": _ctx.beforeAvatarUpload,
        "on-change": 
                (file) => {
                    _ctx.handleChange(file,2);
                }
            
      }, {
        default: _withCtx(() => [
          (_ctx.bannerUrl)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: _ctx.bannerUrl,
                class: "avatar"
              }, null, 8, ["src"]))
            : (_openBlock(), _createBlock("i", _hoisted_3))
        ]),
        _: 1
      }, 8, ["before-upload", "on-change"]),
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_el_upload, {
        class: "avatar-uploader",
        action: "https://jsonplaceholder.typicode.com/posts/",
        "show-file-list": false,
        "before-upload": _ctx.beforeAvatarUpload,
        "on-change": 
                (file) => {
                    _ctx.handleChange(file,3);
                }
            
      }, {
        default: _withCtx(() => [
          (_ctx.middleUrl)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: _ctx.middleUrl,
                class: "avatar"
              }, null, 8, ["src"]))
            : (_openBlock(), _createBlock("i", _hoisted_7))
        ]),
        _: 1
      }, 8, ["before-upload", "on-change"]),
      _hoisted_8
    ])
  ]))
}